class NewsletterPopup {
  constructor() {
    // First ensure the details-modal custom element is defined
    if (!customElements.get("details-modal")) {
      this.waitForCustomElement();
    } else {
      this.initAfterDelay(500);
    }
  }

  waitForCustomElement() {
    // This creates a MutationObserver to watch for custom element definition
    let observer = new MutationObserver((mutations) => {
      if (customElements.get("details-modal")) {
        observer.disconnect();
        this.initAfterDelay(500);
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // Fallback timeout in case MutationObserver doesn't catch it
    setTimeout(() => {
      observer.disconnect();
      this.initAfterDelay(1000);
    }, 5000);
  }

  initAfterDelay(delay) {
    setTimeout(() => {
      this.initializePopup();
    }, delay);
  }

  initializePopup() {
    // Try multiple selectors to find the modal
    this.popup = document.querySelector(".newsletter-popup-modal");

    // Check for elements with high z-index that might block the popup
    this.findElementsWithHighZIndex();

    // Check if there are any captcha elements blocking the UI
    const captchaElements = document.querySelectorAll(
      '[id*="captcha"], [class*="captcha"], [id*="recaptcha"], [class*="recaptcha"]'
    );
    if (captchaElements.length > 0) {
      console.warn("Captcha elements detected:", captchaElements.length);
      captchaElements.forEach((el) => {
        console.log(
          "Captcha element:",
          el.id || el.className,
          "Style:",
          window.getComputedStyle(el).zIndex
        );
      });
      // Try to ensure they don't block scrolling
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }

    // If not found by class, try finding by data attribute
    if (!this.popup) {
      this.popup = document.querySelector('[data-modal-id="NewsletterPopup"]');
      console.log("Trying to find by data-modal-id:", !!this.popup);
    }

    // If still not found, try finding any details-modal element
    if (!this.popup) {
      const allModals = document.querySelectorAll("details-modal");
      if (allModals.length > 0) {
        this.popup = allModals[0];
        console.log("Using first details-modal found as fallback");
      }
    }

    this.storageKey = "newsletter_popup_shown";
    this.delayInMs = 10000; // Show popup after 3 seconds

    // Only initialize if popup exists and hasn't been shown before
    if (this.popup && !this.hasPopupBeenShown()) {
      this.init();
    } else {
      // If popup element not found, use a simpler approach to show the popup
      if (!this.popup) {
        this.createSimpleModalFallback();
      }
    }
  }

  findElementsWithHighZIndex() {
    const allElements = document.querySelectorAll("*");
    const highZElements = [];

    allElements.forEach((el) => {
      const style = window.getComputedStyle(el);
      const zIndex = parseInt(style.zIndex, 10);
      if (!isNaN(zIndex) && zIndex > 100) {
        highZElements.push({
          element: el,
          id: el.id || "No ID",
          class: el.className || "No Class",
          zIndex: zIndex,
          position: style.position,
        });
      }
    });

    // Sort by z-index in descending order
    highZElements.sort((a, b) => b.zIndex - a.zIndex);

    return highZElements;
  }

  createSimpleModalFallback() {
    // Create a simpler modal without using the details-modal custom element
    const modalHTML = `
      <div id="SimpleNewsletterPopup" class="newsletter-popup-simple" style="
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        display: none;
        justify-content: center;
        align-items: center;
        visibility: visible;
        pointer-events: auto;
      ">
        <div class="newsletter-popup-simple__box" style="
          background-color: white;
          border-radius: 8px;
          padding: 30px;
          max-width: 500px;
          width: 90%;
          position: relative;
          max-height: 80vh;
          overflow-y: auto;
          z-index: 10000;
        ">
          <button type="button" class="newsletter-popup-simple__close" style="
            position: absolute;
            right: 10px;
            top: 10px;
            background: transparent;
            border: none;
            font-size: 24px;
            cursor: pointer;
            padding: 5px;
            z-index: 10001;
          ">&times;</button>
          <h2 style="margin-top: 0;">Subscribe to our newsletter</h2>
          <p>Be the first to know about new collections and exclusive offers.</p>
          <form action="/contact#ContactPopup" class="newsletter-form" method="post">
            <input type="hidden" name="form_type" value="customer">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[tags]" value="newsletter">
            <div style="margin-bottom: 15px;">
              <input id="SimpleNewsletterEmail" type="email" name="contact[email]" style="
                width: 100%;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
              " placeholder="Email" required>
            </div>
            <button type="submit" style="
              background-color: #000;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 4px;
              cursor: pointer;
            ">Subscribe</button>
          </form>
        </div>
      </div>
    `;

    // Remove any existing popup before adding new one
    const existingPopup = document.getElementById("SimpleNewsletterPopup");
    if (existingPopup) {
      existingPopup.remove();
    }

    // Insert the modal into the DOM
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // Store the element and add event listeners
    this.popup = document.getElementById("SimpleNewsletterPopup");

    if (this.popup) {
      // Add close button event listener
      const closeButton = this.popup.querySelector(
        ".newsletter-popup-simple__close"
      );
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.closeSimpleModal();
        });
      }

      // Add event listener to close when clicking outside the modal
      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closeSimpleModal();
        }
      });

      // Add form submission handler
      const form = this.popup.querySelector("form");
      if (form) {
        form.addEventListener("submit", this.handleSubmit.bind(this));
      }

      // Show the popup after delay with forced visibility
      setTimeout(() => {
        this.showSimpleModal();
        // Mark as shown in localStorage
        this.markPopupAsShown();
      }, this.delayInMs);
    }
  }

  showSimpleModal() {
    if (this.popup) {
      // Force any overlays or captchas to go behind our modal
      const captchas = document.querySelectorAll(
        '[id*="captcha"], [class*="captcha"], [id*="recaptcha"], [class*="recaptcha"]'
      );
      captchas.forEach((captcha) => {
        if (captcha.style) {
          console.log("Setting captcha z-index to lower value");
          captcha.style.zIndex = "500";
        }
      });

      // Apply initial styles - opacity 0 for fade-in effect
      this.popup.style.display = "flex";
      this.popup.style.opacity = "0";
      this.popup.style.visibility = "visible";

      // Force all other elements to have lower z-index
      const allBodyChildren = document.body.children;
      for (let i = 0; i < allBodyChildren.length; i++) {
        const element = allBodyChildren[i];
        if (
          element !== this.popup &&
          element.style &&
          !element.id?.includes("SimpleNewsletterPopup")
        ) {
          const currentZIndex = parseInt(
            window.getComputedStyle(element).zIndex,
            10
          );
          if (currentZIndex > 1000) {
            element.dataset.originalZIndex = currentZIndex;
            element.style.zIndex = "999";
          }
        }
      }

      // Apply additional style enhancements to make it more visible
      const modalBox = this.popup.querySelector(
        ".newsletter-popup-simple__box"
      );
      if (modalBox) {
        modalBox.style.boxShadow = "0 0 20px rgba(0,0,0,0.5)";

        // Add a subtle scale animation
        modalBox.style.transform = "scale(0.95)";
        modalBox.style.transition = "transform 0.3s ease, opacity 0.3s ease";
      }

      // Short timeout to force reflow/repaint
      setTimeout(() => {
        // Fade in
        this.popup.style.opacity = "1";
        if (modalBox) {
          modalBox.style.transform = "scale(1)";
        }
      }, 50);

      console.log("Simple modal should be visible now");
    }
  }

  closeSimpleModal() {
    if (this.popup) {
      console.log("Closing simple modal popup");
      this.popup.style.display = "none";

      // Make absolutely sure the element doesn't block clicks
      this.popup.style.visibility = "hidden";
      this.popup.style.pointerEvents = "none";
      this.popup.style.opacity = "0";

      // Restore original z-indexes
      const allBodyChildren = document.body.children;
      for (let i = 0; i < allBodyChildren.length; i++) {
        const element = allBodyChildren[i];
        if (element.dataset?.originalZIndex) {
          element.style.zIndex = element.dataset.originalZIndex;
          delete element.dataset.originalZIndex;
        }
      }

      // Ensure scrolling and pointer events are restored
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.body.style.pointerEvents = "";
      document.documentElement.style.pointerEvents = "";

      // Remove any potential overlay elements
      document
        .querySelectorAll('.modal-overlay, .overlay, [class*="overlay"]')
        .forEach((overlay) => {
          if (overlay !== this.popup) {
            overlay.style.pointerEvents = "none";
            overlay.style.display = "none";
          }
        });

      // Force reflow to apply changes
      document.body.offsetHeight;

      // Remove the modal after a short delay to ensure all interactions are properly reset
      setTimeout(() => {
        if (this.popup && this.popup.parentNode) {
          this.popup.remove();
        }
      }, 100);
    }
  }

  createModalFallback() {
    const modalHTML = `
      <details-modal class="newsletter-popup-modal" data-modal-id="NewsletterPopup">
        <details>
          <summary class="visually-hidden">Subscribe to our newsletter</summary>
          <div class="newsletter-popup-modal__content" tabindex="-1">
            <div class="newsletter-popup-modal__box">
              <button type="button" class="newsletter-popup-modal__close-button" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
              </button>
              <div class="newsletter-popup-modal__content-box">
                <h2 class="newsletter-popup-modal__heading inline-richtext">Subscribe to our newsletter</h2>
                <div class="newsletter-popup-modal__text rte"><p>Be the first to know about new collections and exclusive offers.</p></div>
                <form action="/contact#ContactPopup" class="newsletter-form" method="post">
                  <input type="hidden" name="form_type" value="customer">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="contact[tags]" value="newsletter">
                  <div class="newsletter-form__field-wrapper">
                    <div class="field">
                      <input id="NewsletterPopupForm--direct" type="email" name="contact[email]" class="field__input" value="" aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email" placeholder="Email" required>
                      <label class="field__label" for="NewsletterPopupForm--direct">Email</label>
                      <button type="submit" class="newsletter-form__button field__button" name="commit" id="Subscribe-Popup">
                        <span class="svg-wrapper">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" viewBox="0 0 14 10">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </details>
      </details-modal>
    `;

    document.body.insertAdjacentHTML("afterbegin", modalHTML);
    this.popup = document.querySelector(".newsletter-popup-modal");

    if (this.popup) {
      // Add close button event handler
      const closeButton = this.popup.querySelector(
        ".newsletter-popup-modal__close-button"
      );
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.closeStandardModal();
        });
      }

      this.init();

      // Make sure to add an additional check after initialization to ensure the open attribute is present
      setTimeout(() => {
        if (!this.popup.hasAttribute("open")) {
          this.popup.setAttribute("open", "true");
        }
      }, this.delayInMs + 500);
    }
  }

  init() {
    // Set a timeout to show the popup after the delay
    setTimeout(() => {
      this.showPopup();
    }, this.delayInMs);

    // Mark as shown in localStorage
    this.markPopupAsShown();

    // Add event listener for successful form submission
    const form = this.popup.querySelector("form");
    if (form) {
      form.addEventListener("submit", this.handleSubmit.bind(this));
    }
  }

  showPopup() {
    if (!this.popup) {
      return;
    }

    // Ensure details-modal element is defined
    if (customElements.get("details-modal")) {
      // Add open attribute directly to the details-modal element to match the CSS selector
      this.popup.setAttribute("open", "true");

      // Also trigger the summary click for proper functionality
      const summary = this.popup.querySelector("summary");
      if (summary) {
        summary.click();

        // Add close button event listener
        const closeButton = this.popup.querySelector(
          ".newsletter-popup-modal__close-button"
        );
        if (closeButton) {
          closeButton.addEventListener("click", () => {
            this.closeStandardModal();
          });
        }

        // Apply a fix for the body click event that might not be properly cleaned up
        this.applyEventListenerFix();
      } else {
        // As a fallback, also set open on the details element
        const details = this.popup.querySelector("details");
        if (details) {
          details.setAttribute("open", "true");
        }
      }
    } else {
      // Apply open attribute to both elements as fallback
      this.popup.setAttribute("open", "true");
      const details = this.popup.querySelector("details");
      if (details) {
        details.setAttribute("open", "true");
      }
    }

    // Ensure scrolling is possible
    setTimeout(() => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }, 500);
  }

  applyEventListenerFix() {
    // Fix for potential event listener issues with details-modal
    // The click event on body might not be properly cleaned up
    // This replaces the original event with our own wrapper that can be safely removed
    if (this.popup && typeof this.popup.onBodyClick === "function") {
      // Store the original function reference
      const originalOnBodyClick = this.popup.onBodyClick;

      // Create our wrapped version that can be safely removed
      const wrappedOnBodyClick = (event) => {
        // Only call the original if the modal is open
        if (this.popup && this.popup.hasAttribute("open")) {
          originalOnBodyClick.call(this.popup, event);
        }
      };

      // Replace the original body click event with our wrapper
      document.body.removeEventListener("click", originalOnBodyClick);
      document.body.addEventListener("click", wrappedOnBodyClick);

      // Store the reference to our wrapped function
      this.popup._safeOnBodyClick = wrappedOnBodyClick;
    }
  }

  closeStandardModal() {
    if (this.popup) {
      // Remove open attribute from both elements
      this.popup.removeAttribute("open");

      const details = this.popup.querySelector("details");
      if (details) {
        details.removeAttribute("open");
      }

      // Remove any modal overlays that might be present
      const overlays = document.querySelectorAll(".modal-overlay");
      overlays.forEach((overlay) => {
        overlay.remove();
      });

      // Remove our wrapped body click event if it exists
      if (this.popup._safeOnBodyClick) {
        document.body.removeEventListener("click", this.popup._safeOnBodyClick);
        delete this.popup._safeOnBodyClick;
      }

      // If the original modal has an onBodyClickEvent property, clean it up
      if (this.popup.onBodyClickEvent) {
        document.body.removeEventListener("click", this.popup.onBodyClickEvent);
        delete this.popup.onBodyClickEvent;
      }

      // Ensure all pointer-events are restored
      document.body.style.pointerEvents = "";
      document.documentElement.style.pointerEvents = "";
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";

      // Force a reflow
      document.body.offsetHeight;
    }
  }

  handleSubmit(event) {
    // You could add additional tracking logic here if needed
    console.log("Newsletter form submitted");
  }

  hasPopupBeenShown() {
    return localStorage.getItem(this.storageKey) === "true";
  }

  markPopupAsShown() {
    localStorage.setItem(this.storageKey, "true");
  }
}

// Wait for the DOM to be fully loaded and all scripts to be ready
window.addEventListener("load", () => {
  // Initialize immediately after load
  new NewsletterPopup();
});
